import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import {
  vendorcreate,
  vendordetail,
  vendorlist,
  vendorpublish,
  vendorupdate,
} from "../../../../services/superadmin";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";

export const VendorList = () => {
  const [filterProduct, setFilterProduct] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");

  const columnDefs = [
    {
      headerName: "Actions",
      width: 100,
      field: "id",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellRenderer: function (params) {
        return (
          <a
            title="Edit Vendors"
            className="btn-sm btn-secondary"
            onClick={() => viewvendor(params.value)}
          >
            <i className="fa fa-edit fa-lg"></i>
          </a>
        );
      },
    },
    {
      headerName: "Published",
      width: 100,
      field: "published_status",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <label className="custom-switch mb-0">
              <input
                type="checkbox"
                name="custom-switch-checkbox"
                className="custom-switch-input"
                checked={params.value === 1 ? true : false}
                onChange={() => changestatus(params)}
              />

              <span className="custom-switch-indicator"></span>
            </label>
          </div>
        );
      },
    },
    {
      headerName: "Publish Status",
      width: 120,
      field: "vendor_published_status",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: (params) => {
        if (params.value === "Published") {
          return { color: "green" };
        } else {
          return { color: "red" };
        }
      },
    },

    {
      headerName: "Vendor",
      width: 200,
      field: "vendor_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Contact Number",
      width: 150,
      field: "contact_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Email",
      width: 150,
      field: "email",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Address",
      width: 200,
      field: "address",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  function viewvendor(wid) {
    vendordetail(wid).then((res) => {
      if (res.status === true && res.data.vendor_details) {
        setVID(res.data.vendor_details.id);
        setVenName(res.data.vendor_details.vendor_name);
        setVenEmail(res.data.vendor_details.email);
        setVenPhone(res.data.vendor_details.contact_no);
        setVenAddr(res.data.vendor_details.address);
        setShow(true);
      }
    });
  }

  function changestatus(list) {
    if (list.value == 1) {
      Swal.fire({
        text: "Are you sure want to Unpublish?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ac0404",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Unpublish",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          dotracking(
            "status icon in vendor list from Publish to Unpublish for " +
              list.data.vendor_name +
              " (" +
              list.data.id +
              ") $$ " +
              trackobj.vendorheading
          );
          vendorpublish(localStorage.getItem("UID"), list.data.id, 0).then(
            (response) => {
              if (response.status === true) {
                listall();
                toast.success(response.message);
              }
            }
          );
        }
      });
    } else {
      Swal.fire({
        text: "Are you sure want to Publish?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#008000",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Publish",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          dotracking(
            "status icon in age category list from Unpublish to Publish for " +
              list.data.vendor_name +
              " (" +
              list.data.id +
              ") $$ " +
              trackobj.vendorheading
          );

          vendorpublish(localStorage.getItem("UID"), list.data.id, 1).then(
            (response) => {
              if (response.status === true) {
                listall();
                toast.success(response.message);
              }
            }
          );
        }
      });
    }
  }

  useEffect(() => {
    listall();
  }, []);

  function listall() {
    setFilterProduct([]);
    vendorlist().then((res) => {
      if (res.status === true) {
        setFilterProduct(res.data.vendor_list);
      }
    });
  }
  const [show, setShow] = useState(false);
  const [vid, setVID] = useState(0);
  const [venname, setVenName] = useState("");
  const [venphone, setVenPhone] = useState("");
  const [venemail, setVenEmail] = useState("");
  const [venaddr, setVenAddr] = useState("");
  function handleshow() {
    setVID(0);
    setVenName("");
    setVenPhone("");
    setVenEmail("");
    setVenAddr("");
    setShow(true);
  }

  function handleclose() {
    setShow(false);
    setVID(0);
    setVenName("");
    setVenPhone("");
    setVenEmail("");
    setVenAddr("");
  }

  const handlePhone = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setVenPhone(e.target.value);
    }
  };

  function handleproduct(e) {
    e.preventDefault();
    setErrorMsg("");
    if (venname !== "") {
      if (venphone !== "") {
        if (venphone.length < 10) {
          setErrorMsg("Contact Number must be 10 characters");
        } else {
          if (venemail !== "") {
            let regEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
            if (!regEmail.test(venemail)) {
              setErrorMsg("Please Enter a valid Email ID");
            } else {
              if (venaddr !== "") {
                const temp = new FormData();
                temp.append("admin_id", localStorage.getItem("UID"));
                temp.append("vendor_name", venname);
                temp.append("contact_no", venphone);
                temp.append("email", venemail);
                temp.append("address", venaddr);
                if (vid != 0) {
                  temp.append("vendor_id", vid);
                  dotracking(
                    "update button in the vendor for " +
                      venname +
                      " ( " +
                      vid +
                      " ) " +
                      " with contact - " +
                      venphone +
                      " , email - " +
                      venemail +
                      " , address " +
                      venaddr +
                      " $$ " +
                      trackobj.vendorheading
                  );
                  vendorupdate(temp).then((res) => {
                    if (res.status === true) {
                      handleclose();
                      listall();
                      toast.success(res.message);
                    }
                  });
                } else {
                  dotracking(
                    "add button in the vendor for " +
                      venname +
                      " with contact - " +
                      venphone +
                      " , email - " +
                      venemail +
                      " , address " +
                      venaddr +
                      " $$ " +
                      trackobj.vendorheading
                  );
                  vendorcreate(temp).then((res) => {
                    if (res.status === true) {
                      handleclose();
                      listall();
                      toast.success(res.message);
                    }
                  });
                }
              } else {
                setErrorMsg("Please Enter Address");
              }
            }
          } else {
            setErrorMsg("Please Enter Email ID");
          }
        }
      } else {
        setErrorMsg("Please Enter Contact Number");
      }
    } else {
      setErrorMsg("Please Enter Vendor Name");
    }
  }
  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          <h4 className="mb-0">Vendors List</h4>
        </div>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Products</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Vendors List
          </li>
        </ol>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="text-right">
            <a className="btn btn-success" onClick={handleshow}>
              <i className="fa fa-plus"></i> Add Vendor{" "}
            </a>
          </div>
          <div className="ag-theme-alpine ag-style mt-2">
            <AgGridReact
              columnDefs={columnDefs}
              rowData={filterProduct}
              pagination="true"
              paginationPageSize="10"
              sortingOrder={["asc", "desc"]}
              suppressExcelExport={true}
              suppressDragLeaveHidesColumns={true}
              domLayout="autoWidth"
              onGridReady={(params) => {
                params.api.sizeColumnsToFit();
              }}
            />
          </div>
        </div>
      </div>

      <Modal show={show} size="lg" onHide={handleclose}>
        <Modal.Header>
          {vid !== 0 && <h4> Vendor Details</h4>}
          {vid === 0 && <h4> Add Vendor</h4>}
        </Modal.Header>
        <Modal.Body>
          <Row className="row-sm mx-0">
            <Col lg={12} md={12}>
              <div className="form-group">
                <label className="mb-2">
                  Vendor Name <span className="errortext"> *</span>
                </label>
                <input
                  type="text"
                  placeholder="Vendor Name"
                  className="form-control"
                  value={venname}
                  onChange={(e) => setVenName(e.target.value)}
                />
              </div>
            </Col>

            <Col lg={12} md={12}>
              <div className="form-group">
                <label className="mb-2">
                  Contact Number <span className="errortext"> *</span>
                </label>
                <input
                  type="text"
                  placeholder="Contact Number"
                  className="form-control"
                  value={venphone}
                  onChange={handlePhone}
                  maxLength={10}
                />
              </div>
            </Col>
            <Col lg={12} md={12}>
              <div className="form-group">
                <label className="mb-2">
                  Email ID <span className="errortext"> *</span>
                </label>
                <input
                  type="text"
                  placeholder="Email ID"
                  className="form-control"
                  value={venemail}
                  onChange={(e) => setVenEmail(e.target.value)}
                />
              </div>
            </Col>
            <Col lg={12} md={12}>
              <div className="form-group">
                <label className="mb-2">
                  Address <span className="errortext"> *</span>
                </label>
                <textarea
                  rows="3"
                  placeholder="Address"
                  className="form-control"
                  value={venaddr}
                  onChange={(e) => setVenAddr(e.target.value)}
                />
              </div>
            </Col>
            {errorMsg !== "" && <span className="errortext">{errorMsg}</span>}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <a className="btn btn-danger" onClick={handleclose}>
            Close
          </a>
          {vid !== 0 && (
            <a className="btn btn-success" onClick={handleproduct}>
              Update
            </a>
          )}
          {vid === 0 && (
            <a className="btn btn-success" onClick={handleproduct}>
              Add
            </a>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};
